import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setVisiblePage } from '../reducers/visible-page/visible-page-reducer';
import useIntersectionObserver from './useIntersectionObserver';
var useVisiblePage = function (elementRef, page) {
    var dispatch = useDispatch();
    var entry = useIntersectionObserver(elementRef, { threshold: [0.2, 0.4, 0.6, 0.8, 1.0] });
    useEffect(function () {
        dispatch(setVisiblePage({ page: page, intersectionRatio: entry === null || entry === void 0 ? void 0 : entry.intersectionRatio }));
    }, [entry === null || entry === void 0 ? void 0 : entry.intersectionRatio]);
};
export default useVisiblePage;
